import React, { useEffect, useState } from 'react';
import { getNameClient } from './../../../helpers/nameClient';
import { useSelector, useDispatch } from 'react-redux';
import PageTitle from '../../../components/Common/MetaTagsHelper/metaTagsHelper';
import { Col, Container } from 'reactstrap';
import Swal from 'sweetalert2';

import { getTasks, addTasks, updateTasks, deleteTasks } from '../../../store/Tasks/actions';

import Breadcrumbs from '../../../components/Common/Breadcrumb/Breadcrumb';
import { ITable } from '../../../components/Common/iComponents/iTable/ITable';
import { IPopUp } from '../../../components/Common/iComponents/iPopUp/IpopUp';
import FormTasks from './form-Tasks';
import { ISwitch } from '../../../components/Common/iComponents/iSwitch/iSwitch';
import { ISelector } from '../../../components/Common/iComponents/iSelector/iSelector';
import { IInput } from '../../../components/Common/iComponents/iInput/iInput';

import { getClients } from '../../../store/actions';
import usePageTitle from '../../../common/hooks/usePageTitle';

const TasksList = (props: any) => {
    const dispatch = useDispatch();
    const { tasks, CountItems } = useSelector((state: any) => state.Tasks);
    const { clients } = useSelector((state: any) => state.clients);

    const valuesSizeClientsPagination = [10, 20, 30, 40, 50, 100];
    const [, setPaginationClients] = useState<any>({
        sizePerPage: valuesSizeClientsPagination[0],
        page: 1,
    });

    const PageTitleTask = usePageTitle(props.location.pathname);

    const [tableViewList] = useState([]);
    const [popUpState, setpopUpState] = useState(false);
    const [updateState, setUpdateState] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const [tasksData, setTasksData] = useState([]);

    const valuesSizePagination = [10, 20, 30, 40, 50, 100];
    const [pagination, setPagination] = useState<any>({
        sizePerPage: valuesSizePagination[0],
        page: 1,
    });

    const[ order, setOrder ]= useState( "{'id': 'ASC'}" )

    const initialArrayTable = [
        {
            text: 'ID',
            dataField: 'id',
            formatter: (cellContent: any, tasks: any) => <>{tasks.id}</>,
            hidden: false,
        },
        {
            text: 'Company',
            dataField: 'empresa',
            formatter: (cellContent: any, tasks: any) => <>{tasks.empresa}</>,
            hidden: true,
        },
        {
            text: 'Description',
            dataField: 'descripcion',
            formatter: (cellContent: any, tasks: any) => <>{tasks.descripcion}</>,
            hidden: false,
        },
        {
            text: 'Enabled',
            dataField: 'enabled',
            formatter: (cellContent: any, tasks: any) => {
                return (
                    <ISwitch
                        checked={tasks.enabled}
                        onChangeBooleanHandler={(args) => {
                            const newObject = { ...tasks };
                            newObject.enabled = args;
                            dispatch(
                                updateTasks({
                                    tasks: newObject,
                                    pagination,
                                    data: {...queryString, order },
                                }),
                            );
                        }}
                    />
                );
            },
            hidden: false,
        },
        {
            text: 'Code',
            dataField: 'code',
            formatter: (cellContent: any, tasks: any) => <>{tasks.code}</>,
            hidden: false,
        },
        {
            text: 'createdAt',
            dataField: 'createdAt',
            formatter: (cellContent: any, tasks: any) => <>{tasks.createdAt}</>,
            hidden: true,
        },
        {
            text: 'updatedAt',
            dataField: 'updatedAt',
            formatter: (cellContent: any, tasks: any) => <>{tasks.updatedAt}</>,
            hidden: true,
        },
    ];

    useEffect(() => {
        formatData();
    }, [tasks]);

    const formatData = () => {
        setTasksData([]);
        const newArray = tasks.map((item: any) => {
            return {
                ...item,
                enable: item?.enabled?.toString(),
            };
        });
        setTasksData(newArray);
    };

    useEffect(() => {
        dispatch(getClients({}));
    }, [dispatch, pagination]);

    const handleCreateTasks = (tasks: any) => {
        setpopUpState(!popUpState);
        dispatch(addTasks({ tasks, pagination, data: {order} }));
        Swal.fire({
            icon: 'success',
            title: 'Added!!!',
            text: 'New items have been added successfully!!!',
        });
    };

    const handleUpdateTasks = (tasks: any) => {
        setpopUpState(!popUpState);
        dispatch(updateTasks({ tasks, pagination, data: {...queryString, order} }));
        Swal.fire({
            icon: 'success',
            title: 'Updated!!!',
            text: 'New items have been updated successfully!!!',
        });
    };

    const handleDeleteTasks = (id: any) => {
        Swal.fire({
            title:"Are you sure?",
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            
            customClass: {
                confirmButton: 'custom-confirm-button',
                cancelButton: 'custom-cancel-button',
            },
            
            }).then((result) => {
            if (result.isConfirmed) {
                setpopUpState(!popUpState);
                dispatch(deleteTasks({ id, pagination, data:{order} }));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!!!',
                    text: 'Items have been deleted successfully!!!',
                });
            } 
            
            });
    };

    const handleCancel = (id: any) => {
        setpopUpState(!popUpState);
    };

    const onPopUpState = () => {
        setpopUpState(!popUpState);
    };

    const handleActionOnRowClick = (row: any) => {
        setSelectedRow(row);
    };

    const handleAddAction = () => {
        setUpdateState(false);
        setpopUpState(!popUpState);
        setSelectedRow(null);
    };

    const handlePaginationChange = (newState: any) => {
        setPagination(newState);
    };

    const [queryObject, setQueryObject] = useState<any>({});
    const [queryString, setQueryString] = useState<any>({});

    const initialArrayTableClients = [
        {
            text: 'Id',
            dataField: 'id',
            formatter: (cellContent: any, clients: any) => <>{clients.id}</>,
            hidden: false,
        },
        {
            text: 'Name',
            dataField: 'name',
            formatter: (cellContent: any, clients: any) => <>{clients.name}</>,
            hidden: false,
        },
    ];

    useEffect(() => {
        formatData();
        dispatch(getTasks({ pagination, data: {...queryString, order} }));
    }, [dispatch, pagination]);

    const textClient = 'Search Client ID';
    const textDescripcion = 'Search Descripcion';

    useEffect(() => {
        let taskDescripcion = false;

        const queryTextIdentificator = queryString[textDescripcion] ?? '';

        if (queryTextIdentificator.length > 3 || queryTextIdentificator === '') {
            taskDescripcion = true;
        }

        if (taskDescripcion) {
            formatData();
            dispatch(getTasks({ pagination, data: {...queryString, order} }));
        }
    }, [queryString, order]);

    const handlePaginationClientsChange = (newState: any) => {
        setPaginationClients(newState);
    };
    const onChangeSelectorHandler = (n: any, value: any) => {
        setQueryString({ ...queryString, [n]: value.id });
        setQueryObject({ ...queryObject, [n]: value });
    };

    const onChangeHandler = (e: any, n: any) => {
        if (n === 'Search Client ID') {
            const newObject = clients.filter((item: any) => Number(item.id) === Number(e.target.value))[0];
            setQueryObject({ ...queryObject, [n]: newObject });
        }
        setQueryString({ ...queryString, [n]: e.target.value });
    };

    const handleTableSort = (type :any, { sortField, sortOrder }:any) => {
        setOrder( `{'${sortField}' : '${sortOrder.toUpperCase()}'}` )
    }

    const AdminFilters = () => {
        return (
            <>
                <div className="col-5">
                    <div className="justify-content-center">
                        <ISelector
                            title={textClient}
                            value={queryObject[textClient]?.id || queryString[textClient] || ''}
                            nameSelector={queryObject[textClient]?.name ?? ''}
                            valuesSizePagination={valuesSizeClientsPagination}
                            CountItems={clients.length}
                            dataSelector={clients}
                            initialArrayTable={initialArrayTableClients}
                            handlePaginationChange={handlePaginationClientsChange}
                            setSelectedRow={onChangeSelectorHandler}
                            onChangeHandler={onChangeHandler}
                        />
                    </div>
                </div>
                <div className="col-5">
                    <div className="justify-content-center">
                        <IInput title={textDescripcion} type={'text'} value={queryString[textDescripcion]} onChangeHandler={onChangeHandler} />
                    </div>
                </div>
            </>
        );
    };

    return (
        <React.Fragment>
            <div id="main" style={{ overflow: 'auto' }}>
                <div id="navbar"></div>
                <div className="pageContent">
                    <PageTitle>
                        <title>{PageTitleTask.replace(/-/g, ' ')} | {getNameClient()}</title>
                    </PageTitle>
                    <Container fluid>
                        <div className="row justify-content-center me-2">
                            <div className="d-flex justify-content-end pb-3">
                                <button type="button" className="btn bg-primary text-white add-primary-button" onClick={handleAddAction}>
                                    + Add
                                </button>
                            </div>
                            {AdminFilters()}
                        </div>

                        <Col lg="12">
                            <ITable
                                valuesSizePagination={valuesSizePagination}
                                CountItems={CountItems}
                                remote={true}
                                data={tasksData}
                                fields={initialArrayTable}
                                tableColumns={initialArrayTable}
                                pagSize={4}
                                pageStartIn={0}
                                showTotal={true}
                                disablePageTitle={true}
                                headerColorT={'bg-primary text-white'}
                                tableViewList={tableViewList}
                                groupName=""
                                handlePopUpState={onPopUpState}
                                actionOnRowClick={handleActionOnRowClick}
                                handlerPaginationState={handlePaginationChange}
                                handleTableSort={handleTableSort}
                            />
                        </Col>
                    </Container>
                </div>
            </div>
            <IPopUp
                stateAdd={popUpState}
                switchStateAdd={setpopUpState}
                stateUpdate={updateState}
                switchStateUpdate={setUpdateState}
                modalTitleAdd={'Tasks'}
                modaleTitleUpdate={'Update Tasks'}
                icon="users"
                colorHeaderPop={'#101340'}
            >
                <FormTasks
                    selectedRow={selectedRow}
                    onCreateTask={handleCreateTasks}
                    onUpdateTask={handleUpdateTasks}
                    onDeleteTask={handleDeleteTasks}
                    onCancel={handleCancel}
                />
            </IPopUp>
        </React.Fragment>
    );
};

export default TasksList;
